/* eslint-disable no-nested-ternary */

import React, { useEffect, useState } from 'react';
import { PageTitle, PseudoStates } from '@cordata/buffet';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';

import {
  referenceAdminInstance as refAdmin,
} from '~/utils';

import useSlice from '~/utils/slice/hook';

import Form from '~/components/ConfiguredReport/Form';

const ConfiguredReportsDetails = () => {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState();

  const { attachToItem } = useSlice();

  useEffect(() => {
    refAdmin
      .get(`/reference-report-configuration/${params.configured_report_id}`)
      .then(r => r.data.data)
      .then(attachToItem)
      .then(setData)
      .catch(setError)
      .then(() => setIsLoading(false));
  }, []);

  const toggleActive = () => {
    const method = !data.attributes.isActive ? 'activate' : 'deactivate';

    refAdmin[method](`/reference-report-configuration/${params.configured_report_id}`)
      .then(r => r.data.data)
      .then(r => setData(r))
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  };

  const exportData = (stuff) => {
    // https://stackoverflow.com/questions/19721439/download-json-object-as-a-file-from-browser
    const dataToExport = stuff.attributes || stuff;

    const filename = dataToExport.reportConfigurationName || 'configured_report';
    const JSONified = JSON.stringify(dataToExport);
    const dataString = `data:text/json;charset=utf-8,${encodeURIComponent(JSONified)}`;
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', dataString);
    downloadAnchorNode.setAttribute('download', `${filename}.json`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };

  return !isLoading && !error
    ? (
      <>
        <PageTitle
          action={
            <>
              <Button
                color="info"
                target="_blank"
                href="https://docs.cordata.io/books/features/page/configuration"
              >
                <FontAwesomeIcon icon="external-link-alt" />

                <span className="d-none d-md-inline ml-2">See Documentation</span>
              </Button>

              <Button onClick={() => exportData(data)}>
                <FontAwesomeIcon icon="file-export" />
                <span className="d-none d-md-inline ml-2">Export</span>
              </Button>

              <Button outline onClick={() => toggleActive()}>
                <FontAwesomeIcon icon={!data.attributes.isActive ? 'toggle-off' : 'toggle-on'} />
                <span className="d-none d-md-inline ml-2">{data.attributes.isActive ? 'Deactivate' : 'Activate'}</span>
              </Button>
            </>
          }
        >
          {data.attributes.reportConfigurationLabel}
        </PageTitle>

        <Form data={data} />
      </>
    ) : (<PseudoStates isLoading={isLoading} error={error} />);
};

export default ConfiguredReportsDetails;
